import { AppState } from '../../state';
import { HeaderState } from './reducer';

export const getHeader = (
  state: AppState,
): HeaderState => state.header;
